import WhatsAppIcon from "../ui/WhatsAppIcon";
import { DARK_BG, DARK_BORDER, WA_LINK, type NavigateFn } from "../../lib/site";
import { trackCtaClick } from "../../utils/analytics";

export default function MobileCTABar({ navigate }: { navigate: NavigateFn }) {
  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50 md:hidden flex"
      style={{ borderTop: `1px solid ${DARK_BORDER}` }}
    >
      <button
        type="button"
        onClick={() => {
          trackCtaClick("mobile_bar_get_quote", "/contact");
          navigate("/contact");
        }}
        className="flex-1 bg-[#FF5500] text-black font-bold py-4 text-sm tracking-wide"
      >
        GET A QUOTE
      </button>
      <a
        href={WA_LINK}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => trackCtaClick("mobile_bar_whatsapp", WA_LINK)}
        className="flex-1 font-bold py-4 text-sm tracking-wide flex items-center justify-center gap-2"
        style={{ backgroundColor: DARK_BG, color: "#F6F3EE" }}
      >
        <WhatsAppIcon size={16} className="text-[#25D366]" />
        WHATSAPP
      </a>
    </div>
  );
}
